import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/catalogos/proyecto-presupuestal/';

/**
 * GET Pruecto Presupuestal
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getProyectoPresupuestales = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Pruecto Presupuestal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getProyectoPresupuestal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Pruecto Presupuestal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postProyectoPresupuestal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Pruecto Presupuestal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchProyectoPresupuestal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Pruecto Presupuestal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteProyectoPresupuestal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Pruecto Presupuestal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarProyectoPresupuestal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
